export const ImportStatus = {
  SUCCESS: "Success",
  FAILURE: "Failure",
  WARNING: "Warning",
};
